import DiarioEscolarRepository from './diarioEscolarRepository';
import PeriodoAvaliativoRepository from './periodoAvaliativoRepository';
import AtividadeAvaliativaRepository from './atividadeAvaliativaRepository';
import DistribuirNotasRepository from './distribuirNotasRepository';
import CorteEtarioRepository from './corteEtarioRepository';
import DetalharAtividadeRepository from './detalharAtividadeRepository';
import ConfiguracaoAnoLetivo from './configuracaoAnoLetivoRepository';
import AuthRepository from './authRepository';
import HomeRepository from './homeRepository';
import TurmaRepository from './turmasRepository';
import DisciplinaRepository from './disciplinaRepository';
import DisciplinaDispensadaRepository from './disciplinaDispensadaRepository';
import ProfessorReportsRepository from './professorReportsRepository';
import CoordenadorReportsRepository from './coordenadorReportsRepository';
import DistribuirConceitoRepository from './distribuirConceitoRepository';
import ConceitosRepository from './conceitosRepository';
import SincronizacaoEiRepository from './sincronizacaoEiRepository';
import AtenaPerfilRepository from './atena/perfilRepository';
import AtenaTelaGrupoRepository from './atena/telaGrupoRepository';
import AtenaTelaSubGrupoRepository from './atena/telaSubGrupoRepository';
import AtenaTelaRepository from './atena/telaRepository';
import AtenaUsuarioRepository from './atena/usuarioRepository';
import AtenaSubPerfilRepository from './atena/perfilSubRepository';
import AutorizacaoDiarioRepository from './autorizacaoDiarioRepository';
import ProfessorRepository from './professorRepository';
import EscolaRepository from './escolaRepository';
import vincularPerfilRepository from './vincularPerfilRepository';
import NotificacaoRepository from './notificacaoRepository';
import PerfilAnoLetivoRepository from './perfilAnoLetivoRepository';
import AreaAtuacaoRepository from './areaAtuacaoRepository';
import AlunoRepository from './AlunoRepository';
import DiarioEscolarAEEeACPRepository from './diarioEscolarAEEeACPRepository';
import GrupoPreparacaoRepository from './grupoPreparacaoRepository';
import PreparacaoRepository from './preparacaoRepository';
import AlimentoRepository from './alimentoRepository';
import ComposicaoPreparacaoRepository from './composicaoPreparacaoRepository';
import TituloCardapioRepository from './tituloCardapioRepository';
import CardapioRepository from './cardapioRepository';
import CardapioEscolaRepository from './cardapioEscolaRepository';
import CardapioTurmaRepository from './cardapioTurmaRepository';
import CancelamentoDiarioRepository from './cancelamentoDiarioRepository';
import TipoMovimentoDepositoRepository from './tipoMovimentoDepositoRepository';
import FornecedorRepository from './fornecedorRepository';
import DepositoDaEscolaRepository from './depositoDaEscolaRepository';
import DepositoGeralSMAERepository from './depositoGeralSMAERepository';
import UsuarioDepositoRepository from './usuarioDepositoRepository';
import FuncionariosRepository from './funcionariosRepository';
import MovimentoDepositoFactory from './movimentoDepositoRepository';
import LocalExternoRepository from './localExternoRepository';
import SaidaTurmaRepository from './saidaTurmaRepository';
import SegmentoEstoque from './segmentoEstoqueRepository';
import ComposicaoAlimentoPadraoRepository from './composicaoAlimentoPadraoRepository';
import GrupoAlimentoMerendaRepository from './grupoAlimentoMerendaRepository';
import CotaAlimentarRepository from './cotaAlimentarRepository';
import MovimentoDiarioMerendaRepository from './MovimentoDiarioMerendaRepository';

const repositories = {
  diarioEscolar: DiarioEscolarRepository,
  diarioEscolarAEEeACP: DiarioEscolarAEEeACPRepository,
  atividadeAvaliativa: AtividadeAvaliativaRepository,
  distribuirNotas: DistribuirNotasRepository,
  periodoAvaliativo: PeriodoAvaliativoRepository,
  corteEtario: CorteEtarioRepository,
  detalharAtividade: DetalharAtividadeRepository,
  configuracaoAnoLetivo: ConfiguracaoAnoLetivo,
  auth: AuthRepository,
  home: HomeRepository,
  turma: TurmaRepository,
  disciplina: DisciplinaRepository,
  disciplinaDispensada: DisciplinaDispensadaRepository,
  professorReports: ProfessorReportsRepository,
  coordenadorReports: CoordenadorReportsRepository,
  distribuirConceito: DistribuirConceitoRepository,
  conceitos: ConceitosRepository,
  sincronizacaoEi: SincronizacaoEiRepository,
  atenaPerfil: AtenaPerfilRepository,
  atenaTelaGrupo: AtenaTelaGrupoRepository,
  atenaTelaSubGrupo: AtenaTelaSubGrupoRepository,
  atenaTela: AtenaTelaRepository,
  atenaUsuario: AtenaUsuarioRepository,
  atenaSubPerfil: AtenaSubPerfilRepository,
  autorizacaoDiario: AutorizacaoDiarioRepository,
  professor: ProfessorRepository,
  escola: EscolaRepository,
  vincularPerfil: vincularPerfilRepository,
  notificacao: NotificacaoRepository,
  perfilAnoLetivo: PerfilAnoLetivoRepository,
  areaAtuacao: AreaAtuacaoRepository,
  aluno: AlunoRepository,
  grupoPreparacao: GrupoPreparacaoRepository,
  preparacao: PreparacaoRepository,
  alimento: AlimentoRepository,
  composicaoPreparacao: ComposicaoPreparacaoRepository,
  tituloCardapio: TituloCardapioRepository,
  cardapio: CardapioRepository,
  cardapioEscola: CardapioEscolaRepository,
  cardapioTurma: CardapioTurmaRepository,
  cancelamentoDiario: CancelamentoDiarioRepository,
  tipoMovimentoDeposito: TipoMovimentoDepositoRepository,
  fornecedorRepository: FornecedorRepository,
  depositoDaEscolaRepository: DepositoDaEscolaRepository,
  depositoGeralSMAERepository: DepositoGeralSMAERepository,
  usuarioDepositoRepository: UsuarioDepositoRepository,
  funcionariosRepository: FuncionariosRepository,
  movimentoDepositoFactory: MovimentoDepositoFactory,
  localExterno: LocalExternoRepository,
  saidaTurma: SaidaTurmaRepository,
  segmentoEstoque: SegmentoEstoque,
  composicaoAlimentoPadrao: ComposicaoAlimentoPadraoRepository,
  grupoAlimentoMerenda: GrupoAlimentoMerendaRepository,
  cotaAlimentar: CotaAlimentarRepository,
  movimentoDiarioMerenda: MovimentoDiarioMerendaRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name],
};

export default RepositoryFactory;
